import * as React from "react";

import { IEditForm } from "../types";

import { withUser } from "src/services/withUser";
import { Input, Button, Checkbox, Icons } from "src/components";
import {
  isLocalUserAdmin,
  isAdmin,
  isOnlyMyLinksUser,
} from "src/services/authorizeUser";
import MarketSelector from "./MarketSelector";

const EditForm: React.FC<IEditForm> = ({
  id,
  onSubmit,
  onDelete,
  isSubmitting,
  submitError,
  validationErrors,
  isValid,
  dirty,
  children,
  markets,
  user,
  values,
  onChangeName,
  onToggleRole,
  onToggleMarket,
}) => {
  const isSuperAdmin = isAdmin(values.roles);
  const isOnlyMyLinks = isOnlyMyLinksUser(values.roles);
  const userIsSuperAdmin = isAdmin(user.roles);
  const userIsLocalAdmin = isLocalUserAdmin(user.roles);
  const isNew = id === "new";

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit();
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeName(event.target.value);
  };

  return (
    <div className="pt-5 px-6 mx-px">
      <form onSubmit={handleSubmit} autoComplete="off">
        {children}

        <div className="flex mb-6">
          <label className="w-48 pt-2 pr-6" htmlFor={`email-${id}`}>
            Username*
          </label>
          <div className="flex-1">
            <Input
              name={`email-${id}`}
              className="w-full"
              disabled={!isNew}
              value={values.email}
              onChange={handleNameChange}
            />
          </div>
        </div>

        {!userIsLocalAdmin && (
          <div className="flex mb-4">
            <Checkbox
              name={`superAdmin-${id}`}
              className="inline-block mr-8 mb-3"
              checked={isSuperAdmin}
              disabled={!userIsSuperAdmin}
              onChange={onToggleRole("SuperAdmin")}
            >
              Super Admin
            </Checkbox>
          </div>
        )}

        {!isSuperAdmin && (
          <>
            <div className="flex mb-4">
              <Checkbox
                name={`normalUser-${id}`}
                className="inline-block mr-8 mb-3"
                checked={isOnlyMyLinks}
                onChange={onToggleRole("OnlyMyLinksUser")}
              >
                "My Links" only
              </Checkbox>
            </div>
            <hr className="mb-6 border-b border-grey-dark" />
            <div className="flex">
              <div className="flex-1 mb-4 pr-6">
                <MarketSelector
                  markets={markets}
                  checkedItems={values.userProfileVisibilities}
                  onToggleMarket={onToggleMarket("userProfileVisibilities")}
                >
                  <p>Market Visibility</p>
                </MarketSelector>
              </div>
              {!userIsLocalAdmin && (
                <>
                  <div className="flex-1 mb-4 pr-6">
                    <MarketSelector
                      markets={markets}
                      checkedItems={values.localContentRoles}
                      onToggleMarket={onToggleMarket("localContentRoles")}
                    >
                      <p>Content Admin</p>
                    </MarketSelector>
                  </div>

                  <div className="flex-1 mb-4">
                    <MarketSelector
                      markets={markets}
                      checkedItems={values.localUserRoles}
                      onToggleMarket={onToggleMarket("localUserRoles")}
                    >
                      <p>User Admin</p>
                    </MarketSelector>
                  </div>
                </>
              )}
            </div>
          </>
        )}

        <div className="flex items-center pt-4 pb-5 bg-grey-transparent sticky pin-b pin-r">
          <Button
            onClick={onDelete}
            type="button"
            size="small"
            background="grey"
            neutral={true}
          >
            <Icons.Circle character="×" className="mr-2" /> Delete
          </Button>
          <div className="flex-1 text-red ml-4">
            {submitError && submitError + " "}
            {Object.values(validationErrors).join(", ")}
          </div>
          <Button
            type="submit"
            background="grey"
            loading={isSubmitting}
            loadingLabel="Saving"
            disabled={!dirty || !isValid}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default withUser(EditForm);



// WEBPACK FOOTER //
// ./src/views/Admin/Users/components/EditForm.tsx